





















































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
@Component({
  components: {},
})
export default class MyDatePicker extends Vue {
  @Prop({ default: "" }) id?: string;
  @Prop({ default: "DD-MM-YYYY" }) format: string;
  @Prop({ default: "" }) value: string;
  @Prop({ default: "" }) label: string;
  @Prop({ default: "" }) backgroundColor: string;
  @Prop({ default: false }) rule: boolean;
  @Prop({ default: () => [] }) errorMessage?: string[];
  @Prop({ default: null }) invalidMsg: string;
  @Prop({ default: false }) required: boolean;
  @Prop({ default: false }) readonly: boolean;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: false }) hideDetails: boolean;
  @Prop({ default: false }) dense: boolean;
  @Prop({ default: false }) filled: boolean;
  @Prop({ default: "" }) max: string;
  @Prop({ default: "" }) min: string;
  error = [];
  show = false;
  formattedDate = "";

  get identifier() {
    return this.id
      ? this.id
      : this.lodash.uniqueId(`datepicker-${new Date().getTime()}-`);
  }

  get myDate() {
    this.formattedDate = "";
    if (this.value) {
      this.formattedDate = this.lodash.join(
        this.lodash.reverse(this.value.split("-")),
        "-"
      );
      const date = moment(this.value, true);
      if (!date.isValid()) {
        return "";
      }
      return this.value;
    }
    return moment(new Date()).format("YYYY-MM-DD");
  }

  set myDate(val) {
    this.$emit("input", val);
    this.formattedDate = moment(val).format(this.format);
  }

  today() {
    const today = moment(new Date()).format("YYYY-MM-DD");
    this.myDate = today;
    // (this.$refs["datepicker"] as any).yearClick = today;
    // (this.$refs["datepicker"] as any).monthClick  = today;
    (this.$refs["datepicker"] as any).yearClick(today);
    (this.$refs["datepicker"] as any).monthClick(today);
    //(this.$refs["datepicker"] as any).pickerDate =moment(new Date()).format("YYYY-MM-DD") ;
  }

  onFormattedDate(val: string) {
    if (val === null) {
      this.myDate = "";
      this.error = [];
      return;
    }
    const date = moment(val, this.format, true);
    if (!date.isValid()) {
      this.error = [].concat(this.$t("message.invalid").toString());
      if (this.rule) {
        this.$emit(
          "input",
          this.lodash.join(this.lodash.reverse(val.split("-")), "-")
        );
      } else {
        this.$emit("input", "");
      }
      return;
    }
    this.myDate = date.format("YYYY-MM-DD");
    this.error = [];
  }

  @Watch("errorMessage")
  onErrorMessageWatch() {
    this.error = [...this.errorMessage];
  }

  get timezone() {
    const md = moment();
    return `${moment.tz.guess()} GMT${md.format("Z")}`;
  }
}
